var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-edit',_vm._g(_vm._b({attrs:{"title":_vm.user.name,"toptitle":_vm.$t('settings.account.profile.edit'),"name":"settings-account-edit","width":400}},'base-edit',_vm.$attrs,false),_vm.$listeners),[_c('settings-account-form',{attrs:{"user":_vm.user,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }